<script setup>
const props = defineProps({ 
  isLargeScreen : Boolean
})
</script>

<template>
  <div style="min-height: 270px; display: inline-flex; justify-content: center; align-items: center;">
    <div style="width: 300px; height: 250px; margin: 10px; padding: 0; background: rgba(0,0,0,.2);">
      <div id="74a58582efed6e302b4a7d99bf4a8270" ></div>
    </div>
    <div v-if="props.isLargeScreen" style="width: 300px; height: 250px; margin: 10px; padding: 0; background: rgba(0,0,0,.2);">
      <!-- 640px以上の画面でのみ表示 -->
      <div id="86ea4edea90ec66bd736e08f0c56f138"></div>
    </div>
  </div>
</template>

<style scoped>
</style>